// extracted by mini-css-extract-plugin
export default {"summaryList":"styles_summaryList__-zLwh"};